import { render, staticRenderFns } from "./globalTip.vue?vue&type=template&id=10e22e1c&scoped=true&"
import script from "./globalTip.vue?vue&type=script&lang=js&"
export * from "./globalTip.vue?vue&type=script&lang=js&"
import style0 from "./globalTip.vue?vue&type=style&index=0&id=10e22e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e22e1c",
  null
  
)

export default component.exports